// Angular
import { Injectable } from '@angular/core';

// Third-party

@Injectable({
  providedIn: 'root'
})

export class UtilitiesService {

  /**
   *
   * @param baseUrl
   * @param params
   * @private
   */
  public buildUrlWithParams(baseUrl: string, params: any): string {
    const queryParams = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
    return `${baseUrl}?${queryParams}`;
  }

  convertDataToCSV(objArray: object[], headerList: string[], dataKeys: string[]) {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';

    // Create the CSV header row
    str += headerList.join(',') + '\r\n';

    // Create the CSV data rows
    for (const obj of array) {
      const line = dataKeys
        .map(key => {
          // Handle multiple fields for concatenation
          if (key.includes(',')) {
            const fields = key.split(',');
            const values = fields.map(field => {
              const value = field.trim().split('.').reduce((o, i) => o?.[i], obj);
              return value === null || value === undefined ? '' : value.toString();
            }).filter(value => value !== ''); // Remove empty values
            return `"${values.join(' ').replace(/"/g, '""')}"`; // Join with space and escape quotes
          }

          // Handle single field
          const value = key.split('.').reduce((o, i) => o?.[i], obj);
          const stringValue = value === null || value === undefined ? '' :
            typeof value === 'object' ? JSON.stringify(value) : value.toString();
          return `"${stringValue.replace(/"/g, '""')}"`; // Escape existing double quotes
        })
        .join(',');
      str += line + '\r\n';
    }

    return str;
  }


  downloadFile(data: object[], filename = 'data', headerList: string[], dataKeys: string[]) {
    const csvData = this.convertDataToCSV(data, headerList, dataKeys);
    console.log(csvData);
    const blob = new Blob(['\ufeff' + csvData], {
      type: 'text/csv;charset=utf-8;'
    });
    const a = document.createElement("a");
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 &&
      navigator.userAgent.indexOf('Chrome') === -1;

    if (isSafariBrowser) {
      a.setAttribute("target", "_blank");
    }
    a.setAttribute("href", url);
    a.setAttribute("download", filename + ".csv");
    a.style.visibility = "hidden";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  /**
   * Dynamically creates an anchor element, sets the href to the provided url, appends the anchor element to the body,
   * clicks the anchor element, and removes the anchor element from the body.
   * @param url
   * @param target
   */
  public dynamicallyCreateAnchorAndNavigate(url: string, target?: string, name?: string): void {
    const anchorElement = document.createElement('a');
    if (name) anchorElement.download = name;
    anchorElement.href = url;
    if (target) {
      anchorElement.target = target;
    }
    document.body.appendChild(anchorElement);
    anchorElement.click();
    document.body.removeChild(anchorElement);
  }
}
